export interface OfferPageDto {
    readonly seoId: string,
    readonly deviceSeoId?: string | null,
    readonly showcaseContext: ShowcaseContext,
    readonly offerType: OfferType,
}

export enum ShowcaseContext {
    INTERNET = ("INTERNET"), INTERNET_AND_MOBILE = ("INTERNET_AND_MOBILE")
}

export enum OfferType {
    INTERNET = ("INTERNET"), MOBILE = ("MOBILE")
}
